import { en } from "./en";
import { ar } from "./ar";

export type Locale = "en" | "ar";

export const translations = { en, ar };

export type TranslationKeys = typeof en;

function getNestedValue(obj: Record<string, unknown>, path: string): string | undefined {
  const keys = path.split(".");
  let current: unknown = obj;
  for (const key of keys) {
    if (current && typeof current === "object" && key in current) {
      current = (current as Record<string, unknown>)[key];
    } else {
      return undefined;
    }
  }
  return typeof current === "string" ? current : undefined;
}

export function t(locale: Locale, path: string): string {
  const dict = translations[locale];
  const value = getNestedValue(dict as Record<string, unknown>, path);
  return value ?? getNestedValue(en as Record<string, unknown>, path) ?? path;
}
